import { useJoinGroup } from '../join.js';
import { useIsStandalone } from '../hooks.js';
import InstallSteps from '../components/InstallSteps.js';
import GroupIdField from './GroupIdField.js';

/**
 * The gate: no group ID on this device, or every stored one has been rejected (§5). The admin
 * sends the players two things — `topspinapp.com` and a group ID — and this screen is where the
 * second one goes in. Install first, then enter the ID, so the ID lands in the storage the
 * home-screen icon actually opens.
 */
export default function JoinGroup({ reason }: { reason: 'first-run' | 'rejected' }) {
  const form = useJoinGroup({ replaceAll: reason === 'rejected' });
  const standalone = useIsStandalone();
  const numbered = !standalone && reason === 'first-run';

  return (
    <div className="screen gate">
      <div className="card">
        {/* The same mark the header carries, so the gate reads as the app the players installed. */}
        <h1 className="gate-title">
          <img src="/mark.svg" alt="" width={28} height={28} />
          <span>Topspin App</span>
        </h1>
        {reason === 'rejected' ? (
          <p className="muted">
            That group ID is no longer valid. Enter the new one, or ask whoever runs your
            group for it.
          </p>
        ) : (
          <>
            <p className="muted">Are you playing this week?</p>
            <p className="muted">Enter your group ID and find out.</p>
          </>
        )}
      </div>

      {numbered && (
        <div className="card">
          <h2>Step 1: Add Topspin App to your home screen</h2>
          <InstallSteps />
        </div>
      )}

      <div className="card">
        <h2>{numbered ? 'Step 2: Enter your group ID' : 'Your group ID'}</h2>
        {numbered && (
          <p className="muted">
            Do this from the home screen icon – enter the group ID sent to you.
          </p>
        )}
        <GroupIdField form={form} label="Group ID" action="Continue" hideLabel />
      </div>
    </div>
  );
}
